<template>
  <div class="bbp-accordion-content-cell-total-time">
    <span>and tracked time</span>
    <span v-if="!isEdit">
      <i class="bbp-icon-clock bbp-accordion-content-item-time__icon"/>
      {{ totalTime }}
    </span>
  </div>
</template>

<script>
import convertSecondsToTime from '@/mixin/convertSecondsToTime'

export default {
  name: 'BBPAccordionContentCellTotalTime',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  mixins: [convertSecondsToTime],
  computed: {
    totalTime () {
      const { totalTime = 0 } = this.item
      const sec = Math.floor(totalTime / 1000)
      if (!sec) return '00:00:00'
      return this.convertSecondsToTime(sec, true)
    }
  }
}
</script>

<style lang="scss" scoped>

  .bbp-accordion-content-cell-total-time {

  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellTotalTime.vue